import LookupPayrollsRequestModelBase from '../_generated/modelBases/lookup-payrolls-request-model-base';

export default class LookupPayrollsRequestModel extends LookupPayrollsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
